import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  createCashIn,
  getCashIn,
  RESET_CASHINOUT,
  selectSuccessCash,
  updateCashEntry,
} from "../../redux/features/cashInOut/CashInOutSlice";
import { selectDayStatus } from "../../redux/features/dayStart/DayStartSlice";
import { toast } from "react-toastify";
import { MdEdit } from "react-icons/md";

const CashIn = ({ cash }) => {
  const dayStatus = useSelector(selectDayStatus);

  const [isOpen, setIsOpen] = useState(false);
  const [amount, setAmount] = useState();
  const [cashInNote, setCashInNote] = useState("");
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const isSuccess = useSelector(selectSuccessCash);

  useEffect(() => {
    if (isOpen && cash) {
      setCashInNote(cash.description);
      setAmount(cash.balance);
    }
  }, [cash, isOpen]);

  const handleOpen = () => {
    if (dayStatus) {
      setIsOpen(true);
    } else {
      toast.error("Day is closed. Cannot place cashIn.");
    }
  };
  const handleClose = () => {
    setIsOpen(false);
    setCashInNote("");
    setAmount();
    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};
    if (!cashInNote) newErrors.cashInNote = "CashIn Note is requried";
    if (!amount) newErrors.amount = "CashIn Amount is requried";
    if (amount <= 0) newErrors.amount = "CashIn Amount always greater then 0";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (cash) {
      const cashInData = {
        id: cash._id,
        description: cashInNote,
        balance: Number(amount),
      };
      await dispatch(updateCashEntry(cashInData));
    } else {
      const cashInData = {
        description: cashInNote,
        balance: Number(amount),
      };
      await dispatch(createCashIn(cashInData));
    }
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      dispatch(RESET_CASHINOUT());
      dispatch(getCashIn());
    }
  }, [isSuccess, dispatch]);

  return (
    <div>
      {/* Button to open the modal */}

      {cash ? (
        <div
          onClick={handleOpen}
          className="bg-[#0D868C] text-center text-white p-1 rounded-lg cursor-pointer"
        >
          <MdEdit className="lg:size-6 size-5" />
        </div>
      ) : (
        <button
          onClick={handleOpen}
          className="fixed bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
        >
          <FaPlus className="md:text-xl text-[1rem]" />
        </button>
      )}

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[650px] w-[90%] mx-auto p-10 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-4 mb-8">
              <h1 className="md:text-[1.75rem] text-[1rem] font-bold text-[#0D868C]">
                {cash ? "Update CashIn" : "Create CashIn"}
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className="md:size-8 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-6 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Cash Reason
                </label>
                <input
                  value={cashInNote}
                  onChange={(e) => setCashInNote(e.target.value)}
                  type="text"
                  placeholder="Write the expense reason"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.cashInNote && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.cashInNote}
                  </p>
                )}
              </div>

              <div className="mb-6 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Cash Amount
                </label>
                <input
                  type="number"
                  min={0}
                  step={1}
                  onWheel={(e) => e.target.blur()}
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Cash amount 300, 400 etc."
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.amount && (
                  <p className="text-red-500 text-sm mt-1">{errors.amount}</p>
                )}
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  className="text-white bg-[#0D868C] md:w-[50%] w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
                >
                  {cash ? "Update CashIn" : "Create CashIn"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CashIn;
